import React from 'react';
import {Box, Typography} from '@mui/material';

/**
 * Reusable KPI card used across National Dashboard pages.
 *
 * Props:
 *   label      {string}        – uppercase small label above the value
 *   value      {string|number} – large primary metric value
 *   subValue   {string}        – optional secondary line below value (e.g. "1,100 / 20,000")
 *   tier       {string}        – optional badge text (e.g. "Moderate", "High")
 *   tierColor  {string}        – badge background color
 *   topColor   {string}        – accent strip color along the top edge
 */
const KpiCard = ({
    label,
    value,
    subValue,
    tier,
    tierColor,
    topColor,
}) => (
    <Box sx={{
        border: '1px solid var(--brand-border, #E5E7EB)',
        borderRadius: '12px',
        backgroundColor: 'var(--brand-surface, #ffffff)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    }}>
        {topColor && <Box sx={{backgroundColor: topColor, height: '6px', flexShrink: 0}}/>}
        <Box sx={{p: 2.5, display: 'flex', flexDirection: 'column', flex: 1}}>
            <Typography sx={{
                fontSize: '11px',
                fontWeight: 700,
                color: '#6A7282',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                mb: 1,
            }}>
                {label}
            </Typography>

            <Typography sx={{
                fontSize: {xs: '32px', md: '40px'},
                fontWeight: 800,
                color: '#052F44',
                lineHeight: 1,
            }}>
                {value}
            </Typography>

            {subValue && (
                <Typography sx={{fontSize: '12px', color: '#6A7282', mt: 0.75}}>
                    {subValue}
                </Typography>
            )}

            {tier && (
                <Box sx={{mt: 'auto', pt: 1.5}}>
                    <Box sx={{
                        display: 'inline-block',
                        backgroundColor: tierColor,
                        color: '#ffffff',
                        fontSize: '12px',
                        fontWeight: 700,
                        px: 1.5,
                        py: 0.4,
                        borderRadius: '20px',
                        whiteSpace: 'nowrap',
                        textAlign: 'center',
                        minWidth: '85px',
                    }}>
                        {tier}
                    </Box>
                </Box>
            )}
        </Box>
    </Box>
);

export default KpiCard;
